import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const renderCard = (card, id) => {
  return (
    <div key={id}>
      {/* This style gives the bubble a two-color shadow that mimics the look of a gradiented border on hover. <style jsx> is used so that this style works flawlessly on all browsers.*/}
      <style>{`
        .bubble-card:hover {
          box-shadow: inset 0px 1px 0px rgba(163, 190, 211, 1),
            inset 2px 1px 0px rgba(255, 255, 255, 1);
        }
      `}</style>

      <div
        key={id}
        className="bubble-card flex flex-col items-center justify-center w-[246px] lg:w-[220px] xl:w-[265px] aspect-square rounded-full border border-secondary hover:border-white transition-all duration-300"
      >
        {card.icon && (
          <img src={card.icon} className="w-[70px] h-[70px]" alt={card.title} />
        )}
        {card.title && (
          <Typography
            component="h3"
            variant="h1"
            className="bg-clip-text text-transparent bg-gradient-to-t from-grad_blue_dk to-grad_blue_lt"
          >
            {card.title}
          </Typography>
        )}
        <Typography
          variant="body1"
          className="w-[90%] mx-auto my-0 md:h-[60px] text-center"
        >
          {card.description}
        </Typography>
      </div>
    </div>
  )
}

const renderItem = (section, id) => {
  return (
    <div
      key={id}
      className="w-full bg-gradient_partnership_bubble rounded-b-[50px] md:rounded-b-[100px]"
    >
      <div className="w-full md:max-w-[620px] lg:max-w-w2_l xl:max-w-w1_xl flex flex-col justify-center items-center px-4 md:px-px1_l xl:px-px1_xl pt-[116px] pb-[70px] mx-auto">
        {/* Title */}
        <Typography
          component="h2"
          variant="h1"
          className="text-center text-text mb-[72px]"
        >
          {section.title}
        </Typography>

        {/* Cards Stack */}
        <div className="flex flex-col md:flex-row flex-wrap lg:flex-nowrap w-full max-w-[320px] md:max-w-[522px] lg:max-w-[1000px] xl:max-w-[1280px] justify-between items-center gap-[30px]">
          {section.cards.map(renderCard)}
        </div>
      </div>
    </div>
  )
}

const PartnershipBubbleBanner = () => {
  return (
    <CMSRender contentType={"PartnershipSection"} renderItem={renderItem} />
  )
}

export default PartnershipBubbleBanner
